import { useTranslation } from 'react-i18next';
import { ShieldX, LogOut } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import dayjs from 'dayjs';

export default function AccountExpiredOverlay() {
  const { t } = useTranslation();
  const { accountExpired, user, logout } = useAuthStore();

  if (!accountExpired) return null;

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  return (
    <div className="fixed inset-0 z-[100] bg-white/90 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-white rounded-lg border border-dark-700 shadow-lg p-8 max-w-md w-full mx-4 text-center">
        <div className="w-16 h-16 rounded-full bg-error-50 flex items-center justify-center mx-auto mb-4">
          <ShieldX size={32} className="text-error-600" />
        </div>

        <h2 className="text-xl font-bold text-dark-100 mb-2">
          {t('account.expiredTitle')}
        </h2>

        <p className="text-dark-400 mb-4">
          {t('account.expiredMessage')}
        </p>

        {user?.expiresAt && (
          <p className="text-sm text-dark-500 mb-6">
            {t('account.expiredOn')}: {dayjs(user.expiresAt).format('DD/MM/YYYY')}
          </p>
        )}

        <button
          onClick={handleLogout}
          className="btn-primary w-full flex items-center justify-center gap-2"
        >
          <LogOut size={18} />
          {t('auth.logout')}
        </button>
      </div>
    </div>
  );
}
